<template>
  <!-- eslint-disable max-len -->
  <div class="form-group">
    <label v-if="label" :for="_uid">{{ $slots.default && $slots.default[0].text || '' }}</label>
    <div :class="{ 'input-group': remove }">
      <input
        :id="_uid"
        :placeholder="placeholder || $slots.default[0].text.trim()"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event)"
        type="number"
        class="form-control"
        :class="{ error: validator && validator.$error }"
        @blur="onBlur"
        @keydown="(event) => { if (!submittable && event.keyCode == 13) { event.preventDefault(); return false; } }"
        :disabled="disabled"
        v-focus="(value != null && value !== '') ? false : autofocus">
      <div v-if="remove" class="input-group-append">
        <button
          class="btn btn-sm"
          @click.prevent="remove">
          X
        </button>
      </div>
      <div v-if="down" class="input-group-append">
        <button
          class="btn btn-sm"
          @click.prevent="down">
          &#9660;
        </button>
      </div>
      <div v-if="up" class="input-group-append">
        <button
          class="btn btn-sm"
          @click.prevent="up">
          &#9650;
        </button>
      </div>
    </div>
    <template v-if="validator && validator.$error">
      <p class="error-msg" v-if="required && !validator.required"><slot>Field</slot> is required</p>
      <p class="error-msg" v-else-if="nonZero && !validator.nonZero">{{ $slots.default[0].text }} must not be 0</p>
      <p class="error-msg" v-else-if="minValue && !validator.minValue">{{ $slots.default[0].text }} must be >= {{ validator.$params.minValue.min }}</p>
      <p class="error-msg" v-else-if="maxValue && !validator.maxValue">{{ $slots.default[0].text }} must be less than {{ validator.$params.maxValue.max }}</p>
      <p class="error-msg" v-else-if="customError">{{ customError.message }}</p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    autofocus: { type: Boolean },
    customErrors: { type: Array, default: () => [] },
    disabled: { type: Boolean },
    down: { type: Function },
    label: { type: Boolean },
    maxValue: { type: [Boolean, String] },
    minValue: { type: [Boolean, String] },
    nonZero: { type: Boolean },
    remove: { type: Function },
    required: { type: Boolean },
    up: { type: Function },
    validator: { type: Object },
    value: { type: [Number, String] },
    submittable: { type: Boolean },
    placeholder: { type: String, default: '' }
  },
  computed: {
    customError() {
      return (this.customErrors || []).find(error => !this.validator[error.validator]);
    }
  },
  methods: {
    onBlur($event) {
      if (this.validator) this.validator.$touch();
      this.$emit('blur', $event);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/inputs/NumberInput.vue